import { render } from "./UserPage_info.vue?vue&type=template&id=0b7c10c9&scoped=true"
import script from "./UserPage_info.vue?vue&type=script&lang=js"
export * from "./UserPage_info.vue?vue&type=script&lang=js"

import "./UserPage_info.vue?vue&type=style&index=0&id=0b7c10c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7c10c9"]])

export default __exports__